import {
  Avatar,
  Box,
  Button,
  ButtonProps,
  Divider,
  IconButton,
  Menu,
  MenuProps,
  styled,
} from '@mui/material';

import { doNotForwardTheseProps } from '@/styles';

export const AvatarContainer = styled(Box)(() => ({
  position: 'relative',
}));

export const StyledAvatar = styled(Avatar, {
  shouldForwardProp: doNotForwardTheseProps('size'),
})<{
  size?: number;
}>(({ size = 40 }) => ({
  height: size,
  width: size,
  fontSize: size / 2.5,
}));

export const AvatarButton = styled(IconButton)(() => ({
  padding: 0,
}));

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    slotProps={{
      root: {
        sx: theme => ({
          marginTop: theme.spacing(1),
          marginLeft: theme.spacing(1),
        }),
      },
      paper: {
        sx: () => ({
          padding: 0,
          '.MuiList-root': {
            padding: 0,
            width: 280,
          },
        }),
      },
    }}
    {...props}
  />
))(() => ({}));

export const MenuDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
}));

export const MenuButton = styled((props: ButtonProps) => (
  <Button variant="text" fullWidth {...props} />
))(({ theme }) => ({
  '&.MuiButton-root': {
    fontWeight: theme.typography.body2.fontWeight,
    justifyContent: 'flex-start',
  },
}));

export const UserBlock = styled(Box)(() => ({
  display: 'flex',
  padding: 0,
  alignItems: 'center',
  textDecoration: 'none',
  color: 'initial',

  '.MuiListItemText-root': {
    margin: 0,
  },
}));
